/**
 * VERSIONE LIBRERIA 3
 */
var RenderText = Render.extend({
    type : 'text',
    classData : 'text',
    classTemplate : 'text',
    mode : BaseElement.VIEW,

    setValue : function(value) {
        var self = this;
        $(self.container).find(self.element_selector).html(value);
    },

    getValue : function() {
        var self = this;
        return $(self.container).find(self.element_selector).html();
    },

    _renderView : function (jQe) {
        var self = this;
        $(jQe).find(self.element_selector).html(self.value);
    },
    //_finalizeView : function(){},

    _renderEdit : function(jQe) {
        this._renderView(jQe);
    },
    _renderSearch : function (jQe) {
        this._renderView(jQe);
    },
    //_finalizeSearch : function (){}

});